const englishShortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const thaiShortMonths = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

export const PrettyDate = (date, format = 'd/m', lang= 'TH') => {
    var myDate = date;
    if (!(date instanceof Date)) {
        myDate = new Date(date);
    }

    var month = myDate.getMonth() + 1;
    var day = myDate.getDate();

    if(format === 'dd/MM/yyyy') {
        return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${myDate.getFullYear()}`;    
    }

    if(format === 'dd MMM yyyy hh:mm:ss') {
        return `${day} ${thaiShortMonths[myDate.getMonth()]} ${myDate.getFullYear() + 543} ${myDate.toLocaleTimeString('th-TH')}`;    
    }

    return `${myDate.getDate()} ${englishShortMonths[myDate.getMonth()]}`;
}